async function gtm_datalayer(eventName, relatedObject = null)
{
    function getCart() {
        return fetch("/cart.js", {
            method: "GET",
            credentials: "include"
        }).then(function (res) {
            return res.json();
        });
    }
    
    window.dataLayer = window.dataLayer || [];
    switch(eventName)
    {
        case 'user_data_ready':
            window.dataLayer.push({
                'userID': customerUserId,
                'customer_crm_id': customerCrmId,
                'event': 'user_data_ready'
            });
        break;

        case 'user_login':
            /*
            const previousPageUrl = document.referrer;
            ex: weirdly previousPageUrl contains https://greiche-dev.myshopify.com/ and not https://greiche-dev.myshopify.com/account/login as expected. Maybe because of recaptcha via onsubmit="window.Shopify.recaptchaV3.addToken(this, &quot;customer_login&quot;); return false;" or multiple redirections put in place.
            So a flag "loginDone" has been put in place just to manage the fact that the customer has used the login form
            It has been initialized when customer clicks on "log in" button
            */
            if (window.localStorage.getItem("loginDone")){
                window.dataLayer.push({
                    'event': 'user_login',
                    'user_id': customerCrmId
                });
                window.localStorage.removeItem("loginDone");
            }
        break;

        case 'user_register':
            /*
            Same, a flag "RegisterDone" has also been put in place just to manage the fact that the customer has used the login form
            It has been initialized when customer clicks on "Register" button
            */
            if (window.localStorage.getItem("RegisterDone")){
                window.dataLayer.push({
                    'event': 'user_register',
                    'user_id': customerCrmId
                });
                window.localStorage.removeItem("RegisterDone");
            }
        break;

        case 'user_status':
            if(customerCrmId == ''){
                var customerStatus = 'guest';
                var customerScanStatus = 'no scan';
                var customerPrescriptionStatus = 'no prescription';
            }
            else{
                var customerStatus = 'registered';
                var customerScanStatus = customerHasScan;
                var customerPrescriptionStatus = customerHasPrescription;
            }
            window.dataLayer.push({
                'event': 'user_status',
                'user_status': customerStatus,
                'user_id': customerCrmId,
                'scan_status': customerScanStatus,
                'prescription_status': customerHasPrescription
            });
        break;

        case 'view_item_list_collection':
            var items = [];
            var collectionTitle = relatedObject[0]['collection-name'];
            for(var i = 0; i < relatedObject.length; i++){
                items[i] = {
                    'item_id'         : relatedObject[i]['id'],
                    'item_variant'    : relatedObject[i]['variant-title'],
                    'item_name'       : relatedObject[i]['name'],
                    'price'           : relatedObject[i]['price'],
                    'item_brand'      : relatedObject[i]['brand'],
                    'item_category'   : relatedObject[i]['category'],
                    'item_list_name'  : relatedObject[i]['collection-name'],
                    'imageURL'        : relatedObject[i]['imageURL'], 
                    'productURL'      : relatedObject[i]['productURL'],
                    'sku'             : relatedObject[i]['sku']
                };
            }
            window.dataLayer.push({
                'productList' : collectionTitle,
                'pageType'    : 'Collection',
                'event'       : 'view_item_list',
                'items'       : items
            });
        break;

        case 'view_item_list_search':
            var items = [];
            for(var i = 0; i < products.length; i++){
                items[i] = {
                    'item_id'         : products[i]['id'],
                    'item_variant'    : products[i]['variant-title'],
                    'item_name'       : products[i]['name'],
                    'price'           : products[i]['price'],
                    'item_brand'      : products[i]['brand'],
                    'item_category'   : products[i]['category'],
                    'item_list_name'  : products[i]['collection-name'],
                    'imageURL'        : products[i]['imageURL'], 
                    'productURL'      : products[i]['productURL'],
                    'sku'             : products[i]['sku']
                };
            }
            window.dataLayer.push({
                'pageType'    : 'Search',
                'event'       : 'view_item_list',
                'items'       : items
            });
        break;

        case 'products_impression':
            var items = [];
            for(var i = 0; i < relatedObject.length; i++){
                items[i] = {
                    'name'       : relatedObject[i]['name'],
                    'id'         : relatedObject[i]['id'],
                    'price'      : relatedObject[i]['price'],
                    'brand'      : relatedObject[i]['brand'],
                    'category'   : relatedObject[i]['category'],
                    'variant'    : relatedObject[i]['variant-title'],
                    'list'       : relatedObject[i]['list'],
                    'position'   : relatedObject[i]['position'] 
                };
            }
            window.dataLayer.push({
                'event': 'productImpression',
                'ecommerce': {
                    'currencyCode': 'CAD',
                    'impressions': items
                }
            });
        break;

        case 'product_click':
            var items = [];
            items[0] = {
                'name'       : relatedObject.dataset.productName,
                'id'         : relatedObject.dataset.productId,
                'price'      : relatedObject.dataset.productPrice,
                'brand'      : relatedObject.dataset.productBrand,
                'category'   : relatedObject.dataset.productCategory,
                'variant'    : relatedObject.dataset.productVariant,
                'position'   : relatedObject.dataset.productPosition 
            };
            window.dataLayer.push({
                'event': 'productClick',
                'ecommerce': {
                    'click': {
                        'actionField': {'list': relatedObject.dataset.productList},
                        'products': items
                    }
                }
            });
        break;

        case 'product_detail':
            window.dataLayer.push({
                'event': 'productDetail',
                'ecommerce': {
                    'detail': {
                        'actionField': {'list': productCategory},
                        'products': [{
                            'name' : productName,
                            'id'   : productId,
                            'price': productPrice,
                            'brand': productBrand,
                            'category': productCategory
                        }]
                    }
                }
            });
        break;

        case 'store_search':
            let termsInput = document.querySelector('#stores-location-term');
            let terms = termsInput?.value || '';
            let selected = document.querySelector("#stores-location")?.value || '';
            window.dataLayer.push({
                'event': 'search',
                'term': terms,
                'selected_area': selected,
                'location': relatedObject.getAttribute('data-show-store'),
                'search_type': 'store locator'
            });
            // Re-init for the next search
            if(termsInput){termsInput.value='';}
        break;

        case 'store_action':
            // For checking/testing behavior
            relatedObject.dataset.event = 'store_action';

            window.dataLayer.push({
                'event': 'store_action',
                'button': 'Book appointment',
                'store_name': relatedObject.getAttribute('data-store-name'),
                'location': relatedObject.getAttribute('data-store-id')
            });
        break;

        case 'promo_view_page':
            window.dataLayer.push({
                'event': 'promoView',
                'ecommerce': {
                    'promoView': {
                        'promotions': [{
                            'id'   : articleId,
                            'name' : articleTitle,
                            'creative': 'blog',
                            'position': 'promotion page'
                        }]
                    }
                }
            });
        break;

        case 'promo_view_carousel':
            window.dataLayer.push({
                'event': 'promoView',
                'ecommerce': {
                    'promoView': {
                        'promotions': [{
                            'id'   : relatedObject.dataset.id,
                            'name' : relatedObject.dataset.name,
                            'creative': 'Home page carousel',
                            'position': relatedObject.dataset.slot
                        }]
                    }
                }
            });
        break;

        case 'promo_click_carousel':
            window.dataLayer.push({
                'event': 'promoClick',
                'ecommerce': {
                    'promoClick': {
                        'promotions': [{
                            'id'   : relatedObject.dataset.id,
                            'name' : relatedObject.dataset.name,
                            'creative': 'Home page carousel',
                            'position': relatedObject.dataset.slot
                        }]
                    }
                }
            });
        break;

        case 'promo_click_menu':
            // For checking/testing behavior
            relatedObject.dataset.event = 'promo_click_menu';
            relatedObject.dataset.id = promotionsArticles[relatedObject.href]; // See header.liquid for promotionsArticles

            window.dataLayer.push({
                'event': 'promoClick',
                'ecommerce': {
                    'promoClick': {
                        'promotions': [{
                            'id'   : relatedObject.dataset.id,
                            'name' : relatedObject.innerHTML,
                            'creative': 'Main menu',
                            'position': relatedObject.dataset.slot
                        }]
                    }
                }
            });
        break;

        case 'checkout_cart_start':
            var items = [];
            const cart = await getCart();
            for(var i = 0; i < cart.length; i++){
                items[i] = {
                    'id'         : cart[i]['id'],
                    'name'       : cart[i]['product_title'],
                    'category'   : cart[i]['product_type'],
                    'brand'      : cart[i]['vendor'],
                    'quantity'   : cart[i]['quantity'],
                    'price'      : cart[i]['price'] / 100,
                };
            }
            const isRxOption = items.some((item) => item.name.toLowerCase().indexOf("rx") >= 0);
            window.dataLayer.push({
                event: 'eec.checkout',
                ecommerce: {
                    checkout: {
                        actionField: {
                            step: 1,
                            option: isRxOption ? "rx" : "plano"
                        },
                        products: items
                    }
                }
            });

        break;

        case 'checkout_user_check':
            window.dataLayer.push({
                event: 'checkout',
                ecommerce: {
                    checkout: {
                        actionField: {
                            step: 2,
                            option: relatedObject
                        }
                    }
                }
            });
        break;

        default:
    }
}